module.exports = __webpack_public_path__ + "static/media/logo_smartersDark.9fbfc014.svg";